import i18n from "./i18n";

export const commonModuleI18n = i18n;
